import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';

@Component({
  selector: 'app-password-reset-dialog',
  templateUrl: './password-reset-dialog.component.html',
  styleUrls: ['./password-reset-dialog.component.scss']
})
export class PasswordResetDialogComponent implements OnInit {
  /**
   * The Form
   */
  dataForm: UntypedFormGroup;
  /**
   * constructor
   * @param dialogRef 
   * @param fb 
   */
  constructor(
    public dialogRef: MatDialogRef<PasswordResetDialogComponent>,
    private fb: UntypedFormBuilder) {

  }
  /**
   * Check if the 2 Fields match
   * @param form 
   * @returns 
   */
  passwordValidator(form: UntypedFormGroup) {
    const condition = form.get('newPassword').value != form.get('passwordRecitation').value;
    return condition ? { passwordsDoNotMatch: true } : null;
  }
  /**
   * ngOnInit
   * init the Form
   */
  ngOnInit() {
    this.dataForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      passwordRecitation: ['', [Validators.required, Validators.minLength(6)]]
    }, {
      validator: this.passwordValidator
    });
  }
  /**
   * close the Dialog
   */
  cancel(): void {
    this.dialogRef.close();
  }

}
